import { render, staticRenderFns } from "./lawTable.vue?vue&type=template&id=3a3792c3&scoped=true"
import script from "./lawTable.vue?vue&type=script&lang=js"
export * from "./lawTable.vue?vue&type=script&lang=js"
import style0 from "./lawTable.vue?vue&type=style&index=0&id=3a3792c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3792c3",
  null
  
)

export default component.exports